import React from 'react';

const YoutubeAdPreview = ({
  videoId,
  actionHeadline = 'Check out our latest offer!',
  actionButtonLabel = 'Learn More',
  finalUrls = ['https://www.example.com'],
}) => {

  const displayUrl = finalUrls[0];

  return (
    <div style={{
      width: '100%',
      maxWidth: '480px',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      borderRadius: '0.5rem',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    }}>
      {/* Video or Fallback */}
      {videoId ? (
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={videoId}
            title="YouTube Video Ad"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          ></iframe>
        </div>
      ) : (
        <div style={{
          backgroundColor: '#000',
          paddingBottom: '56.25%',
          position: 'relative',
          textAlign: 'center',
        }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/1024px-YouTube_full-color_icon_%282017%29.svg.png"
            alt="YouTube"
            style={{
              width: '120px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.6,
            }}
          />
        </div>
      )}

      {/* Sponsored Label */}
      <div style={{
        position: 'absolute',
        top: '0.5rem',
        left: '0.5rem',
        backgroundColor: '#000',
        color: '#fff',
        fontSize: '0.75rem',
        padding: '0.2rem 0.4rem',
        borderRadius: '0.25rem',
        opacity: 0.8,
      }}>
        Ad · Sponsored
      </div>

      {/* Bottom Overlay */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.5rem',
        background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
        color: '#fff',
      }}>
        <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
          {actionHeadline}
        </div>

        <a
          href={displayUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: '#1a73e8',
            color: '#fff',
            fontSize: '0.75rem',
            padding: '0.4rem 0.8rem',
            borderRadius: '0.25rem',
            textDecoration: 'none',
            fontWeight: 'bold',
          }}
        >
          {actionButtonLabel}
        </a>
      </div>
    </div>
  );
};

export default YoutubeAdPreview;
